import React from 'react'
import { Form } from 'antd';
import { Grid, TextField,Snackbar,FormControlLabel,Checkbox } from '@material-ui/core';
import { SitesLookup } from "../../sites/components/lookupForm";
import { NetworksLookup } from "../../networks/components/lookupForm";
import SnackbarContentWrapper from "../../../components/SnackBar";

class siteForm extends React.Component {
  state = {
    confirmDirty: false,
    autoCompleteResult: [],
    sites: this.props.sites ? this.props.sites : [],
    networks: this.props.networks ? this.props.networks : [],
    owner: this.props.owner ? this.props.owner : false,
    snackOpen : false,
    snackType: "info",
    snackMessage: "Action executing..."
  };

  handleClose = () => {
    this.setState({ snackOpen: false });
  };

  setStateValues = (open,type,message) => {
    this.setState({ snackOpen: open });
    this.setState({ snackType: type });
    this.setState({ snackMessage: message });
  }

  handleSubmit = (e) => {
    this.setState({ snackOpen: true });
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        let variables = { id: this.props.id, name: values.name, email: values.email, password: values.password, role: values.role, owner:this.state.owner };
        if(values.password === this.props.password)
        { 
          variables = { id: this.props.id, name: values.name, email: values.email, role: values.role, owner:this.state.owner }; 
        }
        
        this.props.query_f({ variables: variables }).then(result =>{
          this.props.query_access({ variables: { user: result.data.createUser ? result.data.createUser.id : this.props.id, site: this.state.sites }})
          .then(result =>{
            this.setStateValues(true, "success", "Action executed with success! (Sites)");
          }, error=>{
            this.setStateValues(true, "error", "Action executed with error! (Sites)");            
          });
          this.props.query_userNetworks({ variables: { user: result.data.createUser ? result.data.createUser.id : this.props.id, networks: this.state.networks }})
          .then(result =>{
            this.setStateValues(true, "success", "Action executed with success! (Network)");
          }, error=>{
            this.setStateValues(true, "error", "Action executed with error! (Network)");            
          });
          this.props.form.resetFields();
          if(this.props.onCancel){ this.props.onCancel(); }
          localStorage.setItem('adireto-drawer-open', false);
        }, error=>{
          this.setStateValues(true, "error", "Action executed with error! (User)");          
        });
      }
      else{
        this.setStateValues(true, "error", "Form validation failed! (User)");
      }
    });
  }
  handleConfirmBlur = (e) => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  }
  sitesChange = (value) => { 
    this.setState({ sites: value });
  };
  networksChange = (value) => { 
    this.setState({ networks: value });
  };
  handleOwner = (event) => {
    this.setState({ owner: event.target.checked });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const myForm = this.props;
    const sitesData = { sitesData : this.state.sites};
    const networksData = { networksData : this.state.networks};

    return (
      <form id="myForm" onSubmit={this.handleSubmit}>
        <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'right', }} open={this.state.snackOpen} autoHideDuration={6000} onClose={this.handleClose}>
          <SnackbarContentWrapper onClose={this.handleClose} variant={this.state.snackType} message={this.state.snackMessage}/>
        </Snackbar>
        <Grid container spacing={0}>
        <Grid item xs={12}>
          {getFieldDecorator('name', { initialValue: (this.props.name || ''), rules: [{ required: true }], })(
            <TextField id="name" label="name"
                  color="primary" fullWidth style={{ marginTop : 13 }} InputLabelProps={{ shrink : true, }}
                  placeholder="name"/>
          )}
        </Grid>
        <Grid item xs={12}>
          {getFieldDecorator('email', { initialValue: (this.props.email || ''), rules: [{ required: true }], })(
            <TextField id="email" label="email"
                  color="primary" fullWidth style={{ marginTop : 13 }} InputLabelProps={{ shrink : true, }}
                  placeholder="email"/>
          )}
        </Grid>
        <Grid item xs={12}>
          {getFieldDecorator('password', { initialValue: (this.props.password || ''), rules: [{ required: true }], })(
            <TextField id="password" label="password" type="password"
                  color="primary" fullWidth style={{ marginTop : 13 }} InputLabelProps={{ shrink : true, }}
                  placeholder="password"/>
          )}
        </Grid>
        <Grid item xs={12}>
          {getFieldDecorator('role', { initialValue: (this.props.role || ''), rules: [{ required: true }], })(
            <TextField id="role" label="role"
                  color="primary" fullWidth style={{ marginTop : 13 }} InputLabelProps={{ shrink : true, }}
                  placeholder="role"/>
          )}
        </Grid>
        <Grid item xs={12}>
          <SitesLookup form={myForm} sitesData={sitesData} onChange={this.sitesChange}/>
        </Grid>
        
        <Grid item xs={12}>
          <NetworksLookup form={myForm} networksData={networksData} onChange={this.networksChange}/>
        </Grid>
        <Grid item xs={12}>
          {getFieldDecorator('owner', { initialValue: (this.state.owner || ''), rules: [{ required: false }],})(
            <>
              <FormControlLabel
                control={
                  <Checkbox id="isOwner"
                    checked={this.state.owner}
                    value={this.state.owner}
                    onChange = {this.handleOwner}
                    inputProps={{
                      'aria-label': 'primary checkbox',
                    }}
                  />
                }
                style={{marginTop : 10}}
                label="Owner" />
              </>
          )}
        </Grid>

        </Grid>
        </form>
    );
  }
}

const sitesForm = Form.create()(siteForm);

export default sitesForm